import request from "@/utils/request";

export function getStoreProfit() {
  return request({
    url: "/account/my-wallet/h5/store-profit",
    method: "get",
  });
}
export function getStoreData() {
  return request({
    url: "/trade/order/store-data",
    method: "get",
  });
}
export function getStoreDataAnalysis(params) {
  return request({
    url: "/trade/order/store-data-analysis",
    method: "get",
    params,
  });
}
export function getBrandAccessLog(params) {
  return request({
    url: "/trade/order/brand-access-log",
    method: "get",
    params,
  });
}
export function getVisitorAccessLog(params) {
  return request({
    url: "/product/access-log/my/visitor/record",
    method: "get",
    params,
  });
}
export function getOrderNumber(params) {
  return request({
    url: "/trade/order/order/states-number",
    method: "get",
    params,
  });
}
